import { GObject } from "../GObject";
import { Vector2 } from "../Utils";
import { Rectangle } from "../assets/Rectangle";
export class Background extends GObject {
    constructor(props) {
        super({
            position: new Vector2(0, 0),
            dimensions: props.dimensions || new Vector2(500, 500),
            scale: 1,
            rotation: 0,
            children: props.children
        });
        this.color = props.color;
    }
    update(ctx, parent) {
        this.dimensions = parent.dimensions;
        this.sprite = new Rectangle(this.dimensions.getX(), this.dimensions.getY(), this.color);
    }
}
//# sourceMappingURL=Background.js.map